<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar
      :background-color="sidebarBackground"
      :short-title="this.$THEME.webTitle"
      :title="this.$THEME.webTitle">
      <template slot="links">
        <sidebar-item
          v-if="isMember() || (isAdmin() && !this.$THEME.hidePOSFromAdmin)"
          class=""
          :link="{
            name: 'POS',
            icon:
              'fas fa-cash-register ' +
              (this.$THEME.primaryColor ? '' : 'text-blue'),
            color: this.$THEME.primaryColor,
            path: '/pos',
          }" />
        <base-dropdown
          class="nav-item nav-dropdown"
          v-if="isMember() || isAdmin()">
          <a slot="title" class="nav-link" role="button">
            <i
              :class="
                'fas fa-folder-open ' +
                (this.$THEME.primaryColor ? '' : 'text-green')
              "
              v-bind:style="{ color: this.$THEME.primaryColor }"></i>
            <span class="nav-link-text">การขายสินค้า</span>
            <i class="fas fa-caret-down pl-2"></i>
          </a>
          <div class="dropdown-header">
            <h6 class="text-overflow m-0">การขายสินค้า</h6>
          </div>
          <sidebar-item
            :link="{
              name: 'สรุปข้อมูลยอดขาย',
              icon: 'fa fa-list-alt',
              color: this.$THEME.primaryColor,
              path: '/dashboard',
            }" />
          <sidebar-item
            :link="{
              name: 'ประวัติยกเลิกรายการ',
              icon: 'fa fa-trash text-red',
              color: this.$THEME.primaryColor,
              path: `/historycancel`,
            }" />
        </base-dropdown>
        <sidebar-item
          v-if="isAdmin() || isSuperAdmin() || isShippop()"
          :link="{
            name: 'จัดการขนส่ง',
            icon:
              'fas fa-truck ' + (this.$THEME.primaryColor ? '' : 'text-yellow'),
            color: this.$THEME.primaryColor,
            path: '/transports',
          }" />
        <sidebar-item
          v-if="isAdmin()"
          :link="{
            name: 'จัดการสินค้า',
            icon:
              'fas fa-shopping-cart ' +
              (this.$THEME.primaryColor ? '' : 'text-purple'),
            color: this.$THEME.primaryColor,
            path: '/product',
          }" />
        <!-- <sidebar-item
          v-if="isAdmin()"
          :link="{
            name: setNameManageUser(),
            icon:
              'fas fa-user-cog ' +
              (this.$THEME.primaryColor ? '' : 'text-primary'),
            color: this.$THEME.primaryColor,
            path: '/usersmanage',
          }" /> -->
        <!-- <sidebar-item
          v-if="isShippop()"
          :link="{
            name: 'จัดการตัวแทนจำหน่าย (SuperAdmin)',
            icon:
              'fas fa-users ' +
              (this.$THEME.primaryColor ? '' : 'text-warning'),
            color: this.$THEME.primaryColor,
            path: '/agentmanage',
          }" /> -->
        <sidebar-item
          v-if="isSuperAdmin() || isShippop()"
          :link="{
            name: setNameManageShop(),
            icon:
              'fas fa-store ' + (this.$THEME.primaryColor ? '' : 'text-red'),
            color: this.$THEME.primaryColor,
            path: '/brancemanage',
          }" />
        <sidebar-item
          v-if="isAdmin()"
          :link="{
            name: setNameManageUser(),
            icon:
              'fas fa-user-cog ' +
              (this.$THEME.primaryColor ? '' : 'text-primary'),
            color: this.$THEME.primaryColor,
            path: '/usersmanage',
          }" />
        <!-- <sidebar-item
          v-if="isAdmin()"
          :link="{
            name: 'จัดการร้านค้า',
            icon:
              'fas fa-store ' + (this.$THEME.primaryColor ? '' : 'text-red'),
            color: this.$THEME.primaryColor,
            path: '/branceedit/',
          }" /> -->
        <!-- <sidebar-item
          v-if="isShippop()"
          :link="{
            name: 'จัดการสมาชิก',
            icon:
              'fas fa-address-book ' +
              (this.$THEME.primaryColor ? '' : 'text-purple'),
            color: this.$THEME.primaryColor,
            path: '/usershop',
          }" /> -->
        <!-- <sidebar-item
          v-if="isMember() || isAdmin()"
          :link="{
            name: 'จัดการใบนำส่งพัสดุ',
            icon:
              'fas fa-file-signature ' +
              (this.$THEME.primaryColor ? '' : 'text-warning'),
            color: this.$THEME.primaryColor,
            path: '/exportdelivery',
          }" />
        <sidebar-item
          v-if="isMember() || isAdmin()"
          :link="{
            name: 'จัดการลูกค้า',
            icon:
              'fas fa-address-card ' +
              (this.$THEME.primaryColor ? '' : 'text-yellow'),
            color: this.$THEME.primaryColor,
            path: '/membershop',
          }" /> -->
        <!-- <base-dropdown
          class="nav-item nav-dropdown"
          v-if="isMember() || isAdmin()">
          <a slot="title" class="nav-link" role="button">
            <i
              class="fas fa-dolly-flatbed"
              v-bind:style="{ color: this.$THEME.primaryColor }"></i>
            <span class="nav-link-text">จัดการขนส่งเข้ารับ</span>
            <i class="fas fa-caret-down pl-2"></i>
          </a>
          <router-link to="/flefixparcel" class="dropdown-item">
            <img
              :src="
                this.$THEME.replaceUpdateFlashMenu
                  ? this.$THEME.replaceFlashIcon
                  : 'img/courier_icons/FLE.jpg'
              "
              class="fle-icon" />
            <span
              >{{
                this.$THEME.replaceUpdateFlashMenu || "Flash Express"
              }}
              อัพเดทน้ำหนัก</span
            >
          </router-link>
        </base-dropdown> -->
        <!-- <base-dropdown class="nav-item nav-dropdown" v-if="isSuperAdmin()">
          <a slot="title" class="nav-link" role="button">
            <i class="fas fa-clipboard-check text-blue"></i>
            <span class="nav-link-text">ระบบยืนยันตน</span>
            <i class="fas fa-caret-down pl-2"></i>
          </a>
          <div class="dropdown-header">
            <h6 class="text-overflow m-0">เมนูยืนยันตัวตน</h6>
          </div>
          <router-link to="/confirmCommissionSPAdmin" class="dropdown-item">
            <i class="fas fa-id-card"></i>
            <span>ตรวจสอบลงทะเบียนคอมมิชชั่น</span>
          </router-link>
          <router-link to="/resgisterCommission" class="dropdown-item">
            <i class="fas fa-coins"></i>
            <span>ลงทะเบียนคอมมิชชั่น</span>
          </router-link>
        </base-dropdown> -->
        <!-- <base-dropdown class="nav-item nav-dropdown" v-if="isShippop()">
          <a slot="title" class="nav-link" role="button">
            <i
              :class="
                'fas fa-landmark ' +
                (this.$THEME.primaryColor ? '' : 'text-warning')
              "
              v-bind:style="{ color: this.$THEME.primaryColor }"></i>
            <span class="nav-link-text">ระบบบัญชี</span>
            <i class="fas fa-caret-down pl-2"></i>
          </a>
          <div class="dropdown-header">
            <h6 class="text-overflow m-0">เกี่ยวกับลูกค้า COD</h6>
          </div>
          <router-link to="/membercod" class="dropdown-item">
            <i
              class="fas fa-people-carry"
              v-bind:style="{ color: this.$THEME.primaryColor }"></i>
            <span>รายงานลูกค้า</span>
          </router-link>
          <div class="dropdown-header">
            <h6 class="text-overflow m-0">เกี่ยวกับคอมมิชชั่น</h6>
          </div>
          <router-link to="/shop/commission" class="dropdown-item">
            <i
              class="fas fa-clipboard-check"
              v-bind:style="{ color: this.$THEME.primaryColor }"></i>
            <span>รายงานร้านค้า</span>
          </router-link>
          <router-link to="/superadmin/commission" class="dropdown-item">
            <i
              class="fas fa-id-badge"
              v-bind:style="{ color: this.$THEME.primaryColor }"></i>
            <span>รายงาน SuperAdmin</span>
          </router-link>
        </base-dropdown> -->
        <base-dropdown class="nav-item nav-dropdown">
          <a slot="title" class="nav-link" role="button">
            <i
              :class="
                'fas fa-folder-open ' +
                (this.$THEME.primaryColor ? '' : 'text-green')
              "
              v-bind:style="{ color: this.$THEME.primaryColor }"></i>
            <span class="nav-link-text">รายงาน</span>
            <i class="fas fa-caret-down pl-2"></i>
          </a>
          <div class="dropdown-header">
            <h6 class="text-overflow m-0">สรุปรายงาน</h6>
          </div>
          <router-link
            to="/reporttransport"
            class="dropdown-item"
            v-if="isMember() || isAdmin()">
            <i
              class="fas fa-truck-loading"
              v-bind:style="{ color: this.$THEME.primaryColor }"></i>
            <span>พัสดุ</span>
          </router-link>
          <router-link
            to="/reportproduct"
            class="dropdown-item"
            v-if="isMember() || isAdmin()">
            <i
              class="fas fa-box-open"
              v-bind:style="{ color: this.$THEME.primaryColor }"></i>
            <span>สินค้าอื่นๆ</span>
          </router-link>
          <!-- <router-link
            to="/reportdropoffshippop"
            class="dropdown-item"
            v-if="(isMember() || isAdmin()) && getStatusServiceDropoffShippop">
            <i
              class="fab fa-dropbox"
              v-bind:style="{ color: this.$THEME.primaryColor }"></i>
            <span>DROPOFF {{ this.$THEME.webTitle }}</span>
          </router-link>
          <router-link
            to="/reportdelivery"
            class="dropdown-item"
            v-if="isMember() || isAdmin()">
            <i
              class="fas fa-file-contract pl-1"
              v-bind:style="{ color: this.$THEME.primaryColor }"></i>
            <span>ใบนำส่งพัสดุ</span>
          </router-link> -->
          <!-- <router-link
            to="/reportshippop"
            class="dropdown-item"
            v-if="isAdmin() || isSuperAdmin() || isShippop()">
            <i
              class="fas fa-tachometer-alt"
              v-bind:style="{ color: this.$THEME.primaryColor }"></i>
            <span>ระบบ {{ this.$THEME.webTitle }}</span>
          </router-link> -->
          <!-- <router-link to="/reportcod" class="dropdown-item" v-if="!isMaster()">
            <i
              class="fas fa-hand-holding-usd"
              v-bind:style="{ color: this.$THEME.primaryColor }"></i>
            <span>รายงาน COD</span>
          </router-link> -->
          <!-- <router-link
            to="/reportbrance"
            class="dropdown-item"
            v-if="isSuperAdmin() || isMaster() || isShippop()">
            <i
              class="fas fa-chart-line"
              v-bind:style="{ color: this.$THEME.primaryColor }"></i>
            <span>ยอดค้างชำระแต่ละสาขา</span>
          </router-link> -->
          <!-- <router-link
            to="/createbill"
            class="dropdown-item"
            v-if="isShippop()">
            <i
              class="fas fa-coins"
              v-bind:style="{ color: this.$THEME.primaryColor }"></i>
            <span>เก็บเงินปลายทาง</span>
          </router-link> -->
          <!-- <router-link
            to="/report/dropoff"
            class="dropdown-item"
            v-if="checkServices() && !isMaster()">
            <i
              class="fas fa-box"
              v-bind:style="{ color: this.$THEME.primaryColor }"></i>
            <span>รายงาน Drop-off</span>
          </router-link> -->
        </base-dropdown>
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardNavbar from "./DashboardNavbar.vue";
import MenuWallet from "@/components/custom/menu/MenuWallet";
import LocalStorageManagement from "@/constants/LocalStorageManagement";
import { FadeTransition } from "vue2-transitions";

export default {
  name: "DashboardLayout",
  components: {
    DashboardNavbar,
    FadeTransition,
    MenuWallet,
  },
  data() {
    return {
      sidebarBackground: "vue", //vue|blue|orange|green|red|primary
      userLogin: "",
      createdBy: "",
      replaceUpdateFlashMenu:
        this.$THEME.replaceUpdateFlashMenu || "Flash Express",
    };
  },
  mounted() {
    this.userLogin = JSON.parse(localStorage.getItem("user"));
    this.createdBy = localStorage.getItem("created_by");
  },
  methods: {
    setNameManageShop() {
      let name = "จัดการร้านค้า (SP-admin)";
      if (this.isShippop()) {
        name = "จัดการร้้านค้า (ทุกสาขา)";
      }
      return name;
    },
    setNameManageUser() {
      let name = "จัดการสมาชิก";
      if (this.isShippop()) {
        name = "จัดการสมาชิก (SHIPPOP)";
      }
      return name;
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    isAdmin() {
      return this.userLogin.role === "admin";
    },
    isMember() {
      return this.userLogin.role === "member";
    },
    isSuperAdmin() {
      return this.userLogin.role === "superadmin";
    },
    isMaster() {
      return this.userLogin.role === "master";
    },
    isShippop() {
      return this.userLogin.role === "shippop";
    },
    checkServices() {
      if (this.isSuperAdmin()) return false;
      if (this.isShippop()) return true;
      const serviceKey = "additional_service";
      const check = LocalStorageManagement.get(serviceKey);
      if (!check[serviceKey]) return false;
      try {
        return Object.values(check[serviceKey].DROPOFF).some(
          (service) => service.status === true
        );
      } catch (err) {
        console.log(`${this.$options.name}:: ${err}`);
        return false;
      }
    },
  },
  computed: {
    getStatusServiceDropoffShippop() {
      if (this.userLogin.setting) {
        return this.userLogin.setting.dropoff_shippop;
      }

      return false;
    },
    // getStatusServiceUpdateParcelFlash(){

    //   if( this.userLogin.setting ){

    //     return this.userLogin.setting.update_parcel_flash

    //   }

    //   return false
    // }
  },
  watch: {
    $route(to, from) {
      if (from.name == "usershop") {
        this.userLogin = JSON.parse(localStorage.getItem("user"));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fle-icon {
  max-width: 30px;
  box-shadow: 1px 1px 5px 0px #656565;
  height: auto;
  margin-right: 8px;
}
</style>
